import React from "react";
import Feed from "./Feed";
import NavBar from "./NavBar";


function Home() {
  return (
    <div>
      <NavBar />
      <Feed />
    </div>
  );
}

export default Home;
